/* eslint-disable no-console */
import { find, filter, flow, get, last, map, reject, replace } from 'lodash/fp';
import { flowAsync, mapAsync } from '@gcc/nodash';
import findChoice from '../../../../helpers/findChoice';
import { transformAttributeValue, getAttributeValue } from '../../../../helpers/getAttributeValue';
import { copyStylesOverrides, setItemAttribute } from '../../../../api/designBuilder';

const mapWithKey = map.convert({ cap: false });

const getItemAndAttributeId = item => ({
  itemId: get('itemId', item),
  attributeId: flow(get('attributes'), find({ name: 'purchaseOption' }), get('attributeId'))(item),
});

const getMeasurementAttributeValue = transformAttributeValue(replace(/\.0$/, ''));

// key is the option name, value is the attribute to read from
const optionsMappings = {
  height: getMeasurementAttributeValue('height'),
  width: getMeasurementAttributeValue('width'),
  depth: getMeasurementAttributeValue('depth'),
  'Window Name': item =>
    `${get('container.charLabel', item)}${get('charLabel', item)} ${get('container.name', item)}`.substr(0, 10),
};

export default (designId, sourceItem, targetItems) => {
  const sourceOptions = flow(
    mapWithKey((mappingFunc, optionName) => ({
      ...findChoice(optionName, sourceItem),
      mappingFunc,
    })),
    filter(get('optionId')),
  )(optionsMappings);

  const sourceItemId = get('itemId', sourceItem);

  const targets = map(
    item => ({
      targetId: item.itemId,
      overrides: map(
        ({
          choiceId, optionId, optionName, optionType, mappingFunc,
        }) => ({
          choiceId,
          optionId,
          choiceValue: mappingFunc(item),
          optionName,
          optionType,
        }),
        sourceOptions,
      ),
    }),
    targetItems,
  );

  return copyStylesOverrides(designId, sourceItemId, targets).then(({ copyResults, design }) => {
    const setPurchaseOption = flow(getItemAndAttributeId, ({ itemId, attributeId }) =>
      setItemAttribute(designId, itemId, attributeId, 'product-and-install'));

    const updatePurchaseOptions = flowAsync(
      filter('succeeded'),
      map(({ itemId }) => find({ itemId }, targetItems)),
      reject(getAttributeValue('purchaseOption')),
      mapAsync(setPurchaseOption),
      last,
    );

    return updatePurchaseOptions(copyResults)
      .then(updatedDesign => ({
        copyResults,
        design: updatedDesign || design,
      }));
  });
};
